/**
 * Codes `mandatoryScheme` attendus par l’API APRIL (ex. GET .../mandatoryschemes).
 * Ne pas envoyer "SALARIE" — ce n’est pas un code valide côté APRIL.
 */
export function mapToAprilMandatoryScheme(regime: string | undefined | null): string {
  const r = (regime || '').toString().trim().toUpperCase();
  if (!r) return 'SS';

  if (
    r === 'SALARIE' ||
    r === 'RÉGIME GÉNÉRAL' ||
    r === 'REGIME GENERAL' ||
    r === 'REGIME_GENERAL' ||
    r === 'GENERAL' ||
    r === 'FONCTIONNAIRE' ||
    r === 'SS'
  ) {
    return 'SS';
  }

  if (
    r === 'TNS' ||
    r === 'SSI' ||
    r === 'INDEPENDANT' ||
    r === 'INDÉPENDANT' ||
    r === 'PROF_LIBE' ||
    r === 'PROF_MED_NON_MED_NON_SAL' ||
    r === 'ARTISAN_COMMERCANT' ||
    r === 'PROFESSIONS_LIBERALES'
  ) {
    return 'TNS';
  }

  if (r.includes('AGRIC')) return 'Agricole';
  if (r.includes('ALSACE') || r.includes('MOSELLE')) return 'AlsaceMoselle';

  return 'SS';
}
